export const smallCaps = {
  letterSpacing: '0.142em',
  textTransform: 'uppercase'
};
